<bricks-modal (closeDialog)="onCancel()">
  <bricks-modal-header>Stromerzeugungseinheit löschen?</bricks-modal-header>
  <bricks-modal-body>
    <p>
      Möchten Sie die Stromerzeugungseinheit (Technische-Ressource {{ data }}) löschen? Dieser Vorgang kann nicht
      rückgängig gemacht werden. Alle zugehörigen Daten gehen unwiderruflich verloren.
    </p>
  </bricks-modal-body>
  <bricks-modal-footer>
    <div class="flex-row align-right">
      <button type="button" class="bricks-button button-fn-no-background" (click)="onCancel()">Abbrechen</button>
      <button type="button" class="bricks-button button-icon-left button-fn delete-button" (click)="onConfirm()">
        <bricks-icon>bricks-trash</bricks-icon>
        <span>Stromerzeugungseinheit löschen</span>
      </button>
    </div>
  </bricks-modal-footer>
</bricks-modal>
